import { useMutation } from "react-query";
import axios from "axios";
import { MisAPI } from "../../../constants/API";
import { commonHeaders } from "../../../constants/HeadersAPI";
import {
  MisConnectionRequest,
  MisConnectionTestDto,
} from "../../../types/Mis/MisTypes";

export const useTestMisConnection = (branchId: number | null) => {
  return useMutation((payload: MisConnectionRequest) =>
    axios.post<MisConnectionTestDto>(
      MisAPI.testConnection(branchId!),
      payload,
      commonHeaders(),
    ),
  );
};
